import { where, orderBy } from "firebase/firestore";
import { subscribeToCol } from "@/composables/events/handler";
import { desktopNotification } from "@/composables/comms";

let voiceQueueNotification = false;
let commitFn = null;
let dispatchFn = null;
let getClinicData = null;

export function init({ commit, dispatch, clinicDataGetter }) {
	commitFn = commit;
	dispatchFn = dispatch;
	getClinicData = clinicDataGetter;
}

export function subscribe(userGroupId) {
	console.log("[CALL-EVENTS] subscribing to userGroup:", userGroupId);

	try {
		subscribeToCol("call-events", [
			where("userGroupId", "==", userGroupId),
			orderBy("updatedAt", "desc")
		], {
			onInitialLoad: loadCalls,
			onAdded: handleCallEvent,
			onUpdated: handleCallEvent,
			onRemoved: releaseCall,
			onUnsubscribed: () => {
				console.log("[CALL-EVENTS] Unsubscribed from call events");
				if (dispatchFn) {
					dispatchFn("releaseCalls");
				}
			},
			onError: (error) => {
				console.error("[CALL-EVENTS] Subscription error:", {
					code: error.code,
					message: error.message
				});
			}
		});

		voiceQueueNotification = getClinicData()?.options?.voiceQueue?.notification ?? false;
	} catch (err) {
		console.error("[CALL-EVENTS] Subscription error:", err);
		throw err;
	}
}

function handleCallEvent(call) {
	if (call?.callId) {
		console.debug("[CALL-EVENTS]", call.status, call.callId);

		if (call.status === "queued" && voiceQueueNotification) {
			desktopNotification();
		}

		dispatchFn("setCall", call);
	}
}

function releaseCall(call) {
	if (call?.callId) {
		commitFn("releaseCall", call.callId);
	}
}

function loadCalls(snapshot) {
	snapshot?.docs?.forEach(doc => {
		const call = doc.data();
		
		if (call.status === "completed")
			commitFn("releaseCall", call.callId);
		dispatchFn("setCall", call);
	});
}
